import Vue from 'vue'

export const assistantBridge = new Vue()

export function openGlobalAssistant(context = {}) {
  assistantBridge.$emit('open', context)
}
